<template>
  <div>
    <mensagem-somente-pro-teste v-if="dispositivo.apkversion.indexOf('2.66') === 0" />
    <Chat messenger="instagram" />
  </div>
</template>

<script>
import MensagemSomenteProTeste from '../../components/MensagemSomenteProTeste.vue';
import Chat from './Chat.vue';

export default {
  components: {
    Chat,
    MensagemSomenteProTeste
  },
  data() {
    return {
      dispositivo: {}
    };
  },
  mounted() {
    this.dispositivo = JSON.parse(this.$localStorage.get('mobile'));
  }
};
</script>
